import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import moment from 'moment/moment'

import { SupplierPortalService } from '../../../core/services/supplier-portal/supplier-portal.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { FornecedorMotoristaEdit, FornecedorMotoristaVm } from '../../../core/models/supplier-portal.model'
import { ErrorRequestModel } from '../../../core/models/response.model'
import { SupplierPortalDocumentsComponent } from '../supplier-portal-documents/supplier-portal-documents.component'

// Edição de motorista já vinculado — sem nome/cpf, identidade não muda.
// Uso principal: renovar validade de CNH/antecedentes vencidos ou próximos do vencimento,
// e gerenciar os documentos anexados (o id já existe nesse fluxo, diferente do cadastro).
@Component({
  selector: 'modal-driver-edit',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormField, MatInput, MatLabel,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinner,
    MatSlideToggle,
    SupplierPortalDocumentsComponent,
  ],
  templateUrl: './modal-driver-edit.component.html',
  styleUrl: './modal-driver-edit.component.scss',
})
export class ModalDriverEditComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { motorista: FornecedorMotoristaVm },
    private dialogRef: MatDialogRef<ModalDriverEditComponent>,
    private supplierPortalService: SupplierPortalService,
    private snackbar: SnackbarCustomService,
  ) {}

  listCategory: any[] = [
    { id: 'A', description: 'A' },
    { id: 'B', description: 'B' },
    { id: 'C', description: 'C' },
    { id: 'D', description: 'D' },
    { id: 'E', description: 'E' },
  ]

  form!: FormGroup
  saving = false

  ngOnInit(): void {
    this.createForm()
  }

  private createForm(): void {
    const m = this.data.motorista
    this.form = this.fb.group({
      contato: [m.contato || '', Validators.required],
      categoria: [m.categoria || ''],
      numeroRegistro: [m.numeroRegistro || ''],
      validade: [this.parseDate(m.validade), Validators.required],
      antecedentesCriminais: [m.antecedentesCriminais === 'S'],
      antecedentesValidade: [this.parseDate(m.antecedentesValidade)],
    })
  }

  private parseDate(value?: string | null): Date | null {
    if (!value) return null
    const parsed = moment(value, 'DD/MM/YYYY')
    return parsed.isValid() ? parsed.toDate() : null
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return
    }
    this.saving = true
    const v = this.form.value
    const model: FornecedorMotoristaEdit = {
      contato: v.contato,
      tipoContatoId: 4, // Celular — único tipo disponível hoje no portal
      numeroRegistro: v.numeroRegistro || '',
      categoria: v.categoria || '',
      validade: v.validade ? moment(v.validade).format('DD/MM/YYYY') : '',
      antecedentesCriminais: v.antecedentesCriminais ? 'S' : 'N',
      antecedentesValidade: v.antecedentesValidade ? moment(v.antecedentesValidade).format('DD/MM/YYYY') : '',
    }
    this.supplierPortalService.editMotorista(this.data.motorista.id, model).subscribe({
      next: (res: any) => {
        this.snackbar.success(res.message || 'Motorista atualizado com sucesso.')
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: (err: ErrorRequestModel) => { this.saving = false; this.snackbar.errorRequest(err) },
      complete: () => { this.saving = false },
    })
  }

  close(): void { this.dialogRef.close() }
}
